import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import {
  fetchOrgSettings,
  updateOrgSettings,
  DEFAULT_ORG_SETTINGS,
  type OrgSettings,
} from '@/lib/supabase/settings';

export function useOrgSettings() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const { data: settings = DEFAULT_ORG_SETTINGS } = useQuery({
    queryKey: ['org_settings', user?.organization_id],
    queryFn: () => fetchOrgSettings(user!.organization_id!),
    enabled: !!user?.organization_id,
    staleTime: 5 * 60 * 1000,
  });

  const { mutateAsync } = useMutation({
    mutationFn: (patch: Partial<OrgSettings>) =>
      updateOrgSettings(user!.organization_id!, patch),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['org_settings', user?.organization_id] }),
  });

  return { settings, updateSettings: mutateAsync };
}
